import request, { IWorkspaceResponse } from '../http/Xrequest '

// 部门树结构列表
export const getDeptList = async function (): Promise<IWorkspaceResponse<any>> {
  const url = '/system/dept/deptTreeWithNoAuth'
  const result = await request.get(url)
  return result.data
}
